@if (tourService.activeTour()) {
  <!-- SVG Spotlight overlay -->
  <svg class="tour-svg-overlay" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="spotlight-mask">
        <rect width="100%" height="100%" fill="white"/>
        @if (spotlightRect()) {
          <rect
            [attr.x]="spotlightRect()!.x"
            [attr.y]="spotlightRect()!.y"
            [attr.width]="spotlightRect()!.width"
            [attr.height]="spotlightRect()!.height"
            rx="10" fill="black"/>
        }
      </mask>
    </defs>
    <rect width="100%" height="100%" fill="rgba(10,8,26,0.72)" mask="url(#spotlight-mask)"/>
  </svg>

  <!-- Spotlight ring around target -->
  @if (spotlightRect()) {
    <div class="spotlight-ring"
      [style.left.px]="spotlightRect()!.x"
      [style.top.px]="spotlightRect()!.y"
      [style.width.px]="spotlightRect()!.width"
      [style.height.px]="spotlightRect()!.height">
    </div>
  }

  <!-- Tour bubble -->
  <div class="tour-bubble"
    [style.top]="bubblePos().top"
    [style.left]="bubblePos().left"
    [style.transform]="bubblePos().transform">

    <div class="tour-bubble-header">
      <div class="tour-progress-dots">
        @for (step of tourService.activeTour()!.steps; track $index) {
          <span class="tour-dot" [class.active]="$index === tourService.currentStepIndex()"></span>
        }
      </div>
      <button class="tour-skip-btn" (click)="skip()">Skip tour</button>
    </div>

    <div class="tour-bubble-body">
      <h4 class="tour-title">{{ tourService.currentStep()!.title }}</h4>
      <p class="tour-desc">{{ tourService.currentStep()!.body }}</p>
    </div>

    <div class="tour-bubble-footer">
      <span class="tour-step-count">{{ tourService.currentStepIndex() + 1 }} of {{ tourService.totalSteps() }}</span>
      <div class="tour-nav">
        @if (!tourService.isFirstStep()) {
          <button class="tour-btn-ghost" (click)="prev()">Back</button>
        }
        <button class="tour-btn-primary" (click)="next()">
          {{ tourService.isLastStep() ? 'Done ✓' : 'Next →' }}
        </button>
      </div>
    </div>

    <!-- Pointer arrow (decorative) -->
    @if (spotlightRect()) {
      <div class="tour-arrow"></div>
    }
  </div>
}
